/**
 * Clicks on these targets manage their own focus (or host a control that
 * does). `handleGridClick` must not steal focus onto the enclosing `<td>`
 * — that blurs react-select and immediately closes a just-opened menu
 * (LAX-10244). The visible click target on a Combobox is usually the
 * custom SingleValue `<div>`, not the hidden input that has
 * `role="combobox"`, so `.select-trigger` has to be listed explicitly.
 */
export const INTERACTIVE_CELL_SELECTOR = [
    'button',
    'a',
    'input',
    'textarea',
    'select',
    '[role="button"]',
    '[role="checkbox"]',
    '[role="combobox"]',
    '[data-editing-cell="true"]',
    '.select-trigger',
    '.headless-combobox-trigger',
].join(', ');

export const isInteractiveCellTarget = (el: EventTarget | null): boolean =>
    !!el && el instanceof HTMLElement && !!el.closest(INTERACTIVE_CELL_SELECTOR);
